export default __webpack_public_path__ + "static/media/X_A2.3208bb28.mp4";